import { BannerId } from '../../../typings/banners';
import { InternalResourceId } from '../../../typings/internalBanners';

export const CLOSE_IMAGES_INTERNAL_GALLERY = 'CLOSE_IMAGES_INTERNAL_GALLERY';
export type CLOSE_IMAGES_INTERNAL_GALLERY = typeof CLOSE_IMAGES_INTERNAL_GALLERY;

export interface CloseImagesInternalGallery {
    type: CLOSE_IMAGES_INTERNAL_GALLERY;
    bannerId: BannerId;
    resourceId: InternalResourceId;
}

export function closeImagesInternalGalleryAction(
    bannerId: BannerId,
    resourceId: InternalResourceId
): CloseImagesInternalGallery {
    return {
        type: CLOSE_IMAGES_INTERNAL_GALLERY,
        bannerId,
        resourceId
    };
}
